import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, styled } from 'styled-components';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { PermissionsOnboarding } from './components/auth/PermissionsOnboarding';
import { wasOnboardingShown } from './services/permissions';
import { GlobalStyles } from './styles/GlobalStyles';
import { theme } from './styles/theme';

import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Dashboard } from './pages/Dashboard';
import { Inventory } from './pages/Inventory';
import { Sales } from './pages/Sales';
import { Customers } from './pages/Customers';
import { Alerts } from './pages/Alerts';
import { Reports } from './pages/Reports';
import { CatalogSearch } from './pages/CatalogSearch';
import { CatalogLoader } from './components/CatalogLoader';
import { Expenses } from './pages/Expenses';
import { Settings } from './pages/Settings';
import { SalesHistory } from './pages/SalesHistory';
import { AdminUsers } from './pages/AdminUsers';
import { Legal } from './pages/Legal';
import { ForceUpdate } from './components/ForceUpdate';


const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div>Cargando...</div>;
  }
  
  return user ? children : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div>Cargando...</div>;
  }
  
  return !user ? children : <Navigate to="/" />;
};

function PermissionsGate() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!wasOnboardingShown()) {
      const t = setTimeout(() => setShow(true), 400);
      return () => clearTimeout(t);
    }
  }, []);

  if (!show) return null;
  return <PermissionsOnboarding onDone={() => setShow(false)} />;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <ForceUpdate>
        <AuthProvider>
          <PermissionsGate />
          <CatalogLoader />
          <Router>
            <Routes>
            <Route path="/login" element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            } />
            
            <Route path="/register" element={
              <PublicRoute>
                <Register />
              </PublicRoute>
            } />

            <Route path="/terminosycondiciones" element={<Legal />} />
            <Route path="/privacidad" element={<Legal />} />

            <Route path="/" element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="catalog" element={<CatalogSearch />} />
              <Route path="sales" element={<Sales />} />
              <Route path="customers" element={<Customers />} />
              <Route path="alerts" element={<Alerts />} />
              <Route path="reports" element={<Reports />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="settings" element={<Settings />} />
              <Route path="sales-history" element={<SalesHistory />} />
              <Route path="admin/users" element={<AdminUsers />} />
            </Route>
          </Routes>
          </Router>
        </AuthProvider>
      </ForceUpdate>
    </ThemeProvider>
  );
}

export default App;
